<template>
  <div :class="isScroll ? 'flexFooter' : 'footer'" :style="{color: '#515a6e'}" >
    {{copyright}}
  </div>
</template>

<script>
export default {
  name: 'infoFooter',
  data () {
    return {
      token: window.sessionStorage.getItem('token'),
      copyright: '',
      isScroll: true
    }
  },
  methods:{
    
  },
  mounted(){
    setTimeout(function(){
      var EditorH = document.querySelector('#Editor');
      this.isScroll =  ((EditorH.clientHeight + 60) > window.innerHeight)
    },200)
  },
  created(){
    
    const that = this
    let Data = {
      // token: that.token
    }
    that.$api.getCopyrightInfo(Data).then(res => {
      if(res.rescode == 0){
        that.copyright = res.copyRight
      }
    }).catch(err => {});


  }
}
</script>

<style scoped lang="less">
  @import './component.less';
</style>



// WEBPACK FOOTER //
// src/components/aboutFooter.vue